var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-4 ml-4 inner-addon right-addon"},[_c('i',{staticClass:"glyphicon icon sli-magnifier"}),_vm._v(" "),_c('input',{ref:"searchText",staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.placeholder},on:{"input":_vm.textChanged}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c42fef1e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchField.vue
// module id = null
// module chunks = 